import React, { useState, useEffect } from 'react';
import { reportesApi } from '../services/api';
import { useSucursal } from '../context/SucursalContext';
import { formatDate } from '../utils/dateHelpers';

const DIAS_RECORDATORIO = 180; // 6 meses

const Mantenimientos = () => {
  const { getSucursalId, getSucursalNombre } = useSucursal();
  const [mantenimientos, setMantenimientos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMantenimientos();
  }, [getSucursalId()]);

  const loadMantenimientos = async () => {
    setLoading(true);
    try {
      const tienda_id = getSucursalId();
      const params = tienda_id ? { tienda_id } : {};
      const response = await reportesApi.getUltimosMantenimientos(params);
      setMantenimientos(response.data || []);
    } catch (error) {
      console.error('Error cargando mantenimientos:', error);
    } finally {
      setLoading(false);
    }
  };

  const enviarRecordatorio = (cliente) => {
    const telefono = (cliente.telefono_cliente || '').replace(/\D/g, '');
    const equipo = cliente.equipo1_descripcion || 'su equipo';
    const mensaje = `Hola ${cliente.nombre_cliente}, le escribimos de Intersecom. Le recordamos que ya pasaron ${cliente.dias_desde_ultimo} días desde el último mantenimiento de ${equipo} (${formatDate(cliente.ultima_fecha)}). ¿Le gustaría agendar un nuevo mantenimiento?`;
    window.open(`https://wa.me/502${telefono}?text=${encodeURIComponent(mensaje)}`, '_blank');
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Mantenimientos</h1>
          <p className="page-subtitle">{getSucursalNombre()} - Último mantenimiento por cliente</p>
        </div>
      </div>

      <div className="card">
        <p style={{ color: 'var(--text-light)', marginBottom: '16px', fontSize: '14px' }}>
          Clientes con servicio de tipo "Mantenimiento", ordenados por cuánto tiempo ha pasado desde la última vez.
          Los que llevan más de {DIAS_RECORDATORIO} días (6 meses) aparecen marcados para enviarles un recordatorio.
        </p>
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : mantenimientos.length === 0 ? (
          <p style={{ color: 'var(--text-light)' }}>No hay órdenes de tipo Mantenimiento registradas</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Teléfono</th>
                  <th>Equipo</th>
                  <th>Último Mantenimiento</th>
                  <th>Días Transcurridos</th>
                  <th>Sucursal</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {mantenimientos.map((cliente, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: 500 }}>{cliente.nombre_cliente}</td>
                    <td>{cliente.telefono_cliente || '-'}</td>
                    <td>
                      <span title={cliente.equipo1_marca}>{cliente.equipo1_descripcion || '-'}</span>
                    </td>
                    <td>{formatDate(cliente.ultima_fecha)}</td>
                    <td>
                      <span className={`status-badge ${cliente.dias_desde_ultimo >= DIAS_RECORDATORIO ? 'status-pendiente' : 'status-terminada'}`}>
                        {cliente.dias_desde_ultimo} días
                      </span>
                    </td>
                    <td>{cliente.tienda || '-'}</td>
                    <td>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => enviarRecordatorio(cliente)}
                        disabled={!cliente.telefono_cliente}
                        title={cliente.telefono_cliente ? 'Enviar recordatorio por WhatsApp' : 'Cliente sin teléfono registrado'}
                      >
                        Enviar Recordatorio
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Mantenimientos;
